module.exports = __webpack_public_path__ + "static/media/PayementTipScreen.dfa2851d.png";